import React from 'react';
import styled, { css } from 'styled-components';
import DefaultCloseButton from './closeButton';
import { Header as DefaultHeader } from './header';

const Header = styled(DefaultHeader)`
    ${({ borderBottom }) =>
        borderBottom &&
        css`
            border-bottom: 3px solid #002945;
        `}
    justify-content: space-between;
    ${({ backgroundColor }) => backgroundColor && `background: ${backgroundColor};`}
`;

const Headline = styled.h2`
    flex: 0 0 auto;
    margin: 0;
    display: flex;
    align-items: center;
    font-size: 1.1538em;
    font-weight: bold;
`;

const Spacer = styled.span`
    flex: 1 1 0;
    padding: 1px 6px;
`;

const CloseButton = styled(DefaultCloseButton)`
    flex: 1 1 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
`;

export default ({
    className,
    userCanClose,
    headline,
    close,
    backButton,
    borderBottom = true,
    backgroundColor = null
}) => (
    <Header className={className} borderBottom={borderBottom} backgroundColor={backgroundColor}>
        {backButton || <Spacer />}
        <Headline>{headline}</Headline>
        {userCanClose ? <CloseButton onClick={close} /> : <Spacer />}
    </Header>
);
